import ListingLocation from './ListingLocation.component';

export default ListingLocation;
